import queryString from 'query-string';

export const stringifyUrl = (endpoint: string, params: any) => {
  return queryString.stringifyUrl(
    { url: endpoint, query: params },
    { skipNull: true }
  );
};
